import React, { Component } from 'react'

import { JobPinView } from './view'
import { redux } from './redux'
import { debounce } from 'throttle-debounce'

class JobPinContainer extends Component {
  constructor(props) {
    super(props)

    this.dispatchRecordJobClicked = debounce(1500, props.dispatchRecordJobClicked)
  }

  onSelectJob = () => {
    const { job, dispatchSetSelectedJob, dispatchSetAddJobLocation } = this.props

    this.dispatchRecordJobClicked(job.id)

    const viewport = {
      latitude: job.addressLocation.coordinates[1],
      longitude: job.addressLocation.coordinates[0],
      transitionDuration: 500,
    }
    this.props.onViewportChange(viewport)

    dispatchSetSelectedJob(job.id)
    dispatchSetAddJobLocation(null)
  }

  onClosePopup = () => {
    this.props.dispatchSetSelectedJob(null)
  }

  render() {
    return (
      <JobPinView
        {...this.props}
        onSelectJob={this.onSelectJob}
        onClosePopup={this.onClosePopup}
      />
    )
  }
}

const JobPin = redux(JobPinContainer)

export { JobPin }
